module.exports = {
    NODE_ENV: 'development',
    // API_URL: 'https://localhost:44362/api/v1',
    //API_URL: 'https://csdldp-sdc-api.vnptdongthap.com.vn/api/v1',
    API_URL: 'https://ioc-clh-administration-api.vnptdongthap.com.vn/api/v1',
    LOGIN_URL: 'https://ioc-clh-administration-api.vnptdongthap.com.vn/api/v1',
    APPID: '1a244622-0437-41a3-a343-39c654d825cf',
    TINHTP_SITEID: "87",
    TINHTP_SITENAME: "Đồng Tháp",
    QUANHUYEN_SITEID: "866",
    QUANHUYEN_SITENAME: "TP Cao Lãnh",
    CURRENT_PAGE: 1,
    DEFAULT_LIMIT: 10,
    PAGE_OPTION: [{ id: 10, name: "Hiển thị trên cổng 10 dòng", value: 10, text: "Hiển thị trên cổng 10 dòng" }, { id: 30, name: "Hiển thị trên cổng 30 dòng", value: 30, text: "Hiển thị trên cổng 30 dòng" }, { id: 50, name: "Hiển thị trên cổng 50 dòng", value: 50, text: "Hiển thị trên cổng 50 dòng" }],
    GIOITINH: [{ id: 0, name: "Nam" }, { id: 1, name: "Nữ" }],
    LOAITHONGKE_THOIGIAN: [{ id: 0, name: "Thống kê theo năm" }, { id: 1, name: "Thống kê theo quý" }, { id: 2, name: "Thống kê theo tháng" }, { id: 3, name: "Thống kê theo ngày" },],
    LOAITHONGKE_THOIGIAN_THANG: [{ id: 1, name: "Tháng 1" },{ id: 2, name: "Tháng 2" }, { id: 3, name: "Tháng 3" }, { id: 4, name: "Tháng 4" },{ id: 5, name: "Tháng 5" }, { id: 6, name: "Tháng 6" },{ id: 7, name: "Tháng 7" },{ id: 8, name: "Tháng 8" },{ id: 9, name: "Tháng 9" },{ id: 10, name: "Tháng 10" },{ id: 11, name: "Tháng 11" },{ id: 12, name: "Tháng 12" },],
    LOAITHONGKE_THOIGIAN_QUY: [{ id: 1, name: "Quý 1" }, { id: 2, name: "Quý 2" }, { id: 3, name: "Quý 3" }, { id: 4, name: "Quý 4" },],

    ACCEPT_TYPE_EXCEL: '.xlsx,.xls'

}